import { CONDITION_LOOKUP_TABLE, CONDITION_PII_FIELDS } from './hideif';

export type ConditionLookups = Record<
  string,
  { answers: Record<string, unknown> }
>;

export function withConditionPii<T extends object>(
  data: T,
  pii: unknown
): T & { pii: Record<string, unknown> } {
  const source = (pii && typeof pii === 'object' ? pii : {}) as Record<
    string,
    unknown
  >;
  const allowed: Record<string, unknown> = {};

  CONDITION_PII_FIELDS.forEach((field) => {
    allowed[field] = source[field] ?? null;
  });

  return { ...data, pii: allowed };
}

/** CPK-4974: answers of other questionnaires of the claim, read by conditions with `look_up`. */
export function withConditionLookups<T extends object>(
  data: T,
  lookups: ConditionLookups | null | undefined
): T & { lookups: ConditionLookups } {
  return { ...data, lookups: lookups ?? {} };
}

/** CPK-4974: questionnaire ids that some condition of `logics` reads through `look_up`. */
export function referencedQuestionnaireIds(logics: unknown[]): string[] {
  const ids = new Set<string>();
  logics.forEach((logic) => {
    const groups = Array.isArray(logic) ? logic : [logic];
    groups.forEach((group: any) => {
      (Array.isArray(group?.conditions) ? group.conditions : []).forEach(
        (condition: any) => {
          const lookUp = condition?.look_up;
          if (!lookUp || typeof lookUp.questionnaire_id !== 'string') return;
          if (lookUp.table && lookUp.table !== CONDITION_LOOKUP_TABLE) return;
          ids.add(lookUp.questionnaire_id);
        }
      );
    });
  });
  return Array.from(ids);
}
